var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPollff = function SvgPollff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 40 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.355 1.178a1.178 1.178 0 1 0-2.355 0v47.458a1.178 1.178 0 1 0 2.355 0v-6.065h17.308c.86 0 1.556-.697 1.556-1.557v-5.675c0-.86-.697-1.557-1.556-1.557H2.355v-4.481H28.86c1.036 0 1.874-.84 1.874-1.874v-5.041c0-1.035-.84-1.874-1.873-1.874H2.355v-4.48h35.506c1.18 0 2.137-.958 2.137-2.138V9.381c0-1.18-.957-2.138-2.137-2.138H2.355z",
    clipRule: "evenodd"
  })));
};
export default SvgPollff;